module.exports = __webpack_public_path__ + "static/media/aerarann.9b4aa085.png";